import React from "react";
import MapComponent from "./MapComponent";

function App() {
  return <MapComponent />;
}


export default App;